import { planTemplateDelete } from "./deleteTemplate.js";
// Detaches one template from one trip — the "Remove" action on an applied template
// (Doc 07's per-trip counterpart to `deleteTemplate`'s whole-template delete). `rows`
// must already be scoped to this trip; the same detach/delete/makeIndependent decision
// table (Doc 07 §5) applies per row, and the id drops from `importedTemplateIds` so the
// template goes back to "not applied". The template itself, and its rows on any other
// trip, are untouched.
export const planTemplateRemoval = (trip, templateId, mode, rows) => {
    const { actions } = planTemplateDelete(templateId, mode, rows);
    return {
        templateId,
        actions,
        tripPatch: { importedTemplateIds: trip.importedTemplateIds.filter((id) => id !== templateId) },
    };
};
//# sourceMappingURL=removeTemplateFromTrip.js.map